"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importDefault(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var Icon_1 = __importDefault(require("./Icon"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Draggable = react_beautiful_dnd_1.Draggable;
var DragDropItem = function (props) {
    var id = props.id, index = props.index, children = props.children, _a = props.isDragDisabled, isDragDisabled = _a === void 0 ? false : _a, disableInteractiveElementBlocking = props.disableInteractiveElementBlocking, shouldRespectForcePress = props.shouldRespectForcePress;
    var classes = (0, useStyles_1.default)();
    return (react_1.default.createElement(Draggable, { key: id, draggableId: id, index: index, isDragDisabled: isDragDisabled, disableInteractiveElementBlocking: disableInteractiveElementBlocking, shouldRespectForcePress: shouldRespectForcePress }, function (provided, snapshot) {
        var draggableStyle = provided.draggableProps.style || {};
        return (react_1.default.createElement("div", __assign({ ref: provided.innerRef }, provided.draggableProps, { className: classes.item, style: __assign(__assign({}, draggableStyle), { 
                // @ts-ignore
                top: snapshot.isDragging ? draggableStyle.top : 0, 
                // @ts-ignore
                left: snapshot.isDragging ? draggableStyle.left : 0 }) }),
            react_1.default.createElement("div", { className: classes.content }, children),
            !isDragDisabled && (react_1.default.createElement("span", __assign({}, provided.dragHandleProps, { className: classes.icon }),
                react_1.default.createElement(Icon_1.default, null)))));
    }));
};
exports.default = DragDropItem;
